import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function Manifesto() {
  const { t } = useTranslation();
  const items = t("home.manifesto.items", { returnObjects: true }) || [];
  const chapters = items.map((it, i) => ({
    n: String(i + 1).padStart(2, "0"),
    title: it.title,
    body: it.body,
  }));

  return (
    <section className="relative py-24 md:py-32 overflow-hidden" data-testid="manifesto">
      <div className="container-x">
        <div className="flex items-end justify-between mb-14 md:mb-20">
          <div>
            <div className="label-eyebrow">{t("home.manifesto.eyebrow")}</div>
            <h2 className="mt-4 font-display font-medium text-forest text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tightest max-w-3xl">
              {t("home.manifesto.headline")}
            </h2>
          </div>
          <div className="hidden md:block text-right">
            <div className="font-mono text-[11px] tracking-[0.24em] uppercase text-ink/50">
              {t("home.manifesto.chaptersLabel")}
            </div>
            <div className="font-display text-2xl text-forest">01 — 06</div>
          </div>
        </div>

        <div className="divide-y divide-forest/10 border-y border-forest/10">
          {chapters.map((c, i) => (
            <ChapterRow key={c.n} chapter={c} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ChapterRow({ chapter, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1], delay: (index % 3) * 0.05 }}
      className="grid grid-cols-12 gap-6 py-10 md:py-14 group"
      data-testid={`manifesto-chapter-${chapter.n}`}
    >
      <div className="col-span-12 md:col-span-2">
        <div className="font-serif italic text-6xl md:text-7xl text-forest/85 leading-none">
          {chapter.n}
        </div>
      </div>
      <div className="col-span-12 md:col-span-6">
        <h3 className="font-display font-medium text-forest text-2xl md:text-4xl leading-[1.05] tracking-tight">
          {chapter.title}
        </h3>
      </div>
      <div className="col-span-12 md:col-span-4 md:pt-2">
        <p className="text-ink/70 text-base leading-relaxed">{chapter.body}</p>
      </div>
    </motion.div>
  );
}
